// extracted by mini-css-extract-plugin
export var img = "svg-img-module--img--vu18b";
export var svgImg = "svg-img-module--svg-img--KU1YH";